module.exports = __webpack_public_path__ + "sf-pro-text-bold.svg?cae688d0cf94e0e5b2c514dc9b3a9a5e";